export const ADVANCED_TOOL_ROUTES = {
  "Merge PDF": "/dashboard/merge",
  "Split PDF": "/dashboard/split",
  "Rearrange PDF": "/dashboard/rearrange",
  "Compress PDF": "/dashboard/compress",
  "OCR PDF": "/dashboard/ocr",
  "E-sign PDF": "/dashboard/esign",
  "Add Password": "/dashboard/addpass",
  "Remove Password": "/dashboard/removepass",
  "PDF to Word": "/dashboard/pdf-tools",
  "PDF to Excel": "/dashboard/pdf-tools",
  "PDF to PowerPoint": "/dashboard/pdf-tools",
  "Text to PDF": "/dashboard/text2pdf",
};

export const getAdvancedToolRoute = (toolName) =>
  ADVANCED_TOOL_ROUTES[toolName] || "/dashboard/home";

export const getPostAuthRoute = (toolName) =>
  toolName ? getAdvancedToolRoute(toolName) : "/dashboard/home";
